import { createContext } from 'react';

const CategoriaAppContext = createContext();

export default CategoriaAppContext;
